import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';
import { Table } from 'reactstrap';
import moment from 'moment';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js";
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

import api from "../../../../api/";
import functions from '../../../../functions/';

moment.lang('es', {
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  monthsShort: 'Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.'.split('_'),
  weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
  weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
  weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
});

import './styles.css';

const ESTADOS = {
  'PE':"PENDIENTE",
  "PP":"PENDIENTE YA PAGO",
  "CA":"CANCELADO",
  "PR":"PARA SER FACTURADO",
  "FA":"FACTURADO",
  "CO":"CONFIRMADO",
};

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      PorcentajeRecargo : 0,
      PorcentajeDescuento : 0,
      PorcentajeIIBB : 0,
      ImporteRecargo : 0,
      ImporteDescuento : 0,
      ImporteIVA : 0,
      ImporteIIBB : 0,
      Total : 0,
      SubTotal : 0,
      Numero : '',
      Fecha : '',
      Observacion : '',
      CompradorModoEnvio : '',
      CompradorEmail : '',
      CompradorNombre : '',
      CompradorLocalidad : '',
      CompradorProvincia : '',
      CompradorDocumento : '',
      CompradorTelefono : '',
      CompradorCodPostal : '',
      CompradorDomicilioEntrega : '',
      DetalleCondicionDePago : '',
      Estado : '',
      Detalle : [],
      postVariables: ['Estado'],
      errors: [],
      Embalaje: 0,
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    id: PropTypes.func,
    action: PropTypes.oneOf(['DETAIL', 'CANCELAR', 'CONFIRMAR']).isRequired,
  }

  resetForm() {
    this.setState({
      id: null,
      PorcentajeRecargo : 0,
      PorcentajeDescuento : 0,
      PorcentajeIIBB : 0,
      ImporteRecargo : 0,
      ImporteDescuento : 0,
      ImporteIVA : 0,
      ImporteIIBB : 0,
      Total : 0,
      SubTotal : 0,
      Numero : '',
      Fecha : '',
      Observacion : '',
      CompradorModoEnvio : '',
      CompradorEmail : '',
      CompradorNombre : '',
      CompradorLocalidad : '',
      CompradorProvincia : '',
      CompradorDocumento : '',
      CompradorTelefono : '',
      CompradorCodPostal : '',
      CompradorDomicilioEntrega : '',
      DetalleCondicionDePago : '',
      Estado : '',
      Detalle : [],
      errors: [],
    });
  }

  getData() {
    const { postVariables } = this.state;
    const { action } = this.props;
    let data = {};
    if (action == "CANCELAR") {
      return {
        'Estado': "CA",
      };
    } if (action == "CONFIRMAR") {
      return {
        'Estado': 'PR',
      };
    } else if (action == "PENDIENTE") {
      return {
        'Estado': 'PE',
      };
    } else {
      postVariables.forEach(x => {
        data[x] = this.state[x];
      });
      return data;
    }
  }

  setData(data) {
    if (data.success) {
      this.setState({
        id: data.id,
        PorcentajeRecargo : data.PorcentajeRecargo,
        PorcentajeDescuento : data.PorcentajeDescuento,
        PorcentajeIIBB : data.PorcentajeIIBB,
        ImporteRecargo : data.ImporteRecargo,
        ImporteDescuento : data.ImporteDescuento,
        ImporteIVA : data.ImporteIVA,
        ImporteIIBB : data.ImporteIIBB,
        Total : data.Total,
        SubTotal : data.SubTotal,
        Numero : data.Numero,
        Fecha : data.Fecha,
        Observacion : data.Observacion,
        CompradorModoEnvio : data.CompradorModoEnvio,
        CompradorEmail : data.CompradorEmail,
        CompradorNombre : data.CompradorNombre,
        CompradorLocalidad : data.CompradorLocalidad,
        CompradorProvincia : data.CompradorProvincia,
        CompradorDocumento : data.CompradorDocumento,
        CompradorTelefono : data.CompradorTelefono,
        CompradorCodPostal : data.CompradorCodPostal,
        CompradorDomicilioEntrega : data.CompradorDomicilioEntrega,
        DetalleCondicionDePago : data.DetalleCondicionDePago,
        Estado : data.Estado,
        Detalle : data.Detalle,
        permisos_checked: data.permisos_id,
      })
    }
  }

  setErrors(errors) {
    this.setState({
      errors: errors,
    });
  }

  onChangeField(field, value) {
    this.setState(prevState => {
      let errors = prevState.errors;
      if (errors) errors[field] = null;
      prevState.errors = errors;
      prevState[field] = value;
      return prevState;
    });
  }

  getError(field) {
    let errors = this.state.errors;
    if (errors) return errors[field];
    else return null;
  }

  modalVars() {
    const { action } = this.props;
    if (action == "DETAIL") {
      return {
        get: true,
        submitType: null,
        title: "Detalle de Pedido",
        buttonTitle: "Ver",
        danger: false,
        buttonIcon: "fa fa-search fa-lg",
        successMessage: "",
        cancelButtonLabel:"Cerrar",
        saveButton: false,
        buttonClass: "",
        disabled: true,
        id: this.props.id,
      };
    } else if (action == "CANCELAR") {
      return {
        get: true,
        submitType: "PUT",
        title: "Cancelar Pedido",
        buttonTitle: "Cancelar",
        warning: false,
        danger: true,
        buttonIcon: "fa fa-times fa-lg",
        successMessage: "El Pedido ha sido cancelado con éxito.",
        saveButtonLabel: "Confirmar",
        cancelButtonLabel:"Cerrar",
        buttonClass: "btn-danger",
        disabled: true,
        saveButton: true,
        id: this.props.id,
      };
    } else if (action == "CONFIRMAR") {
      return {
        get: true,
        submitType: "PUT",
        title: "Confirmar Pedido",
        buttonTitle: "Confirmar",
        danger: false,
        warning: false,
        cancelButtonLabel:"Cerrar",
        buttonIcon: "fa fa-check fa-lg",
        successMessage: "El Pedido ha sido confirmado con éxito.",
        saveButton: true,
        saveButtonLabel: "Confirmar",
        buttonClass: "btn-success",
        disabled: true,
        id: this.props.id,
      };
    } else if (action == "PENDIENTE") {
      return {
        get: true,
        submitType: "PUT",
        title: "Poner Pedido Como Pendiente",
        buttonTitle: "Pendiente",
        cancelButtonLabel:"Cerrar",
        danger: false,
        warning: true,
        buttonIcon: "fa fa-repeat fa-lg",
        successMessage: "El Pedido ha sido reestablecido con éxito.",
        saveButton: true,
        saveButtonLabel: "Confirmar",
        buttonClass: "btn-warning",
        disabled: true,
        id: this.props.id,
      };
    }
  }

  render() {
    let vars = this.modalVars();
    const { action } = this.props;
    const {
      PorcentajeRecargo, PorcentajeDescuento,
      PorcentajeIIBB, ImporteRecargo, ImporteDescuento,
      ImporteIVA, ImporteIIBB, Total, SubTotal, Numero,
      Fecha, Observacion, CompradorModoEnvio, CompradorEmail,
      CompradorNombre, CompradorLocalidad, CompradorProvincia,
      CompradorDocumento, CompradorTelefono,
      CompradorCodPostal, CompradorDomicilioEntrega,
      DetalleCondicionDePago, Estado, Detalle, Embalaje
    } = this.state;

    if (Fecha != '' && action == "DETAIL") vars.title = `Pedido realizado el ${moment(Fecha).format("DD-MM-YYYY HH:MM")}`;

    let stringFlete = Observacion.lastIndexOf('%')
    let dataFlete = Observacion.slice(stringFlete-2,stringFlete).trim();

    return (
      <ParadigmaModal
        getUrl={(vars.get ? api.gestion.ventas.pedidos : null)}
        submitUrl={(vars.submitType ? api.gestion.ventas.pedidos : null)}
        submitType={vars.submitType}
        id={vars.id}
        className="modal-xl"

        onGotData={(data) => this.setData(data)}
        onGotErrors={(errors) => this.setErrors(errors)}
        onSubmit={(e) => this.props.onSubmit(e)}
        onClose={() => this.resetForm()}
        onPreSubmit={() => this.getData()}

        title={vars.title}
        danger={vars.danger}
        warning={vars.warning}
        buttonClass={vars.buttonClass}
        successMessage={vars.successMessage}
        missingIdMessage={"Debe seleccionar una fila."}
        saveButtonLabel={vars.saveButtonLabel}
        cancelButtonLabel={vars.cancelButtonLabel}
        buttonTitle={vars.buttonTitle}
        buttonIcon={vars.buttonIcon}
        saveButton={vars.saveButton}
        closeButton={true}
      >
        <h5>Comprador</h5>
        <div className="row">
          <div className="col"><strong>{`${CompradorNombre}`}</strong>{` (${CompradorDocumento})`}</div>
          <div className="col">{`Correo: ${CompradorEmail}`}</div>
        </div>
        <div className="row">
          <div className="col">
            {`Domicilio de Entrega: ${CompradorDomicilioEntrega != "" ? CompradorDomicilioEntrega : "NO ESPECIFICADO"} - ${CompradorLocalidad} (CP: ${CompradorCodPostal}) - ${CompradorProvincia}`}
          </div>
        </div>
        <div className="row">
          <div className="col">
            {`Telefono: ${CompradorTelefono}`}
          </div>
        </div>
        <h5 className="pt-2">Infomación</h5>
        <div className="row">
          <div className="col">
            {`Estado: ${Numero == undefined || Numero == null || Numero == ""  ? ESTADOS[Estado] : `${ESTADOS[Estado]} - ${Numero}` }`}
          </div>
        </div>
        <div className="row">
          <div className="col">
            {`Condicion de Pago: ${DetalleCondicionDePago == undefined || DetalleCondicionDePago == null || DetalleCondicionDePago == "" ? "N/A" : DetalleCondicionDePago }`}
          </div>
          <div className="col">
            {`Modo de Envio: ${CompradorModoEnvio == undefined || CompradorModoEnvio == null || CompradorModoEnvio == "" ? "N/A" : CompradorModoEnvio }`}
          </div>
        </div>
        {
          (Observacion == undefined || Observacion == null || Observacion == "") == false &&
          <div className="row">
            <div className="col">
              {Observacion}
            </div>
          </div>
        }
        <h5 className="pt-2">Detalle</h5>
        <Table>
          <thead>
            <tr>
              <td>Codigo</td>
              <td>Descripción</td>
              <td>Color</td>
              <td>Talle</td>
              <td align="center">Cantidad</td>
              <td align="right">Precio sin IVA</td>
              <td align="right">Precio con IVA</td>
              <td align="right">Importe sin IVA</td>
              <td align="right">Importe con IVA</td>
            </tr>
          </thead>
          <tbody>
            {
              Detalle.map((pa, index) => (
                <tr key={"pa-"+index}>
                  <td>{pa.CodigoArticulo}</td>
                  <td>{pa.NombreArticulo}</td>
                  <td>{pa.Color ? pa.Color : ""}</td>
                  <td>{pa.Talle ? pa.Talle : ""}</td>
                  <td align="center">{pa.Cantidad}</td>
                  <td align="right">{`$ ${functions.FormatPrice(pa.PrecioUnitarioSinIVA)}`}</td>
                  <td align="right">{`$ ${functions.FormatPrice(pa.PrecioUnitarioConIVA)}`}</td>
                  <td align="right">{`$ ${functions.FormatPrice(pa.TotalSinIVA)}`}</td>
                  <td align="right">{`$ ${functions.FormatPrice(pa.TotalConIVA)}`}</td>
                </tr>
              ))
            }
          </tbody>
        </Table>
        <div className="row">
          <div className="col text-right">SubTotal:</div>
          <div className="col-1 text-right pl-0 font-weight-bold">{`$ ${functions.FormatPrice(SubTotal)}`}</div>
        </div>
        <div className="row">
          <div className="col text-right">IVA:</div>
          <div className="col-1 text-right pl-0 font-weight-bold">{`$ ${functions.FormatPrice(ImporteIVA)}`}</div>
        </div>
        {
            ImporteIIBB > 0 && PorcentajeIIBB > 0 &&
          <div className="row">
            <div className="col text-right">{`IIBB ${PorcentajeIIBB}%:`}</div>
            <div className="col-1 text-right pl-0 font-weight-bold">{`$ ${functions.FormatPrice(ImporteIIBB)}`}</div>
          </div>
        }
        {
            Observacion.includes("EL EMBALAJE REPRESENTA EL 3% DEL COSTO TOTAL") &&
          <div className="row">
            <div className="col text-right">{`Embalaje 3%:`}</div>
            <div className="col-1 text-right pl-0 font-weight-bold">{`$ ${functions.FormatPrice(Total*0.03)}`}</div>
          </div>
        }
        {
            Observacion.includes("FLETE") ?
            (
              Observacion.includes("%") ?
              (
                <div className="row">
                  <div className="col text-right">{`Flete ${dataFlete}%:`}</div>
                  <div className="col-1 text-right pl-0 font-weight-bold">{`$ ${functions.FormatPrice(Total*(parseInt(dataFlete))/100)}`}</div>
                </div>
              ) :
              (
                <div className="row">
                  <div className="col text-right">{"Flete pendiente de cotización"}</div>
                </div>
              )
            ) : null
        }
        <div className="row">
          <div className="col text-right">Total:</div>
          <div className="col-1 text-right pl-0 font-weight-bold">{`$ ${functions.FormatPrice(Total)}`}</div>
        </div>
      </ParadigmaModal>
      );
    }
  }

  export default Modal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Pedidos/Modal.js